import { ToastProvider } from "@helmr/ui";
import { useMemo } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "./ErrorBoundary";
import { appRoutes } from "./routes";
import { ServicesProvider, type Services } from "./services";

export function App({ services }: { services: Services }) {
  const router = useMemo(() => createBrowserRouter(appRoutes), []);
  return (
    <ServicesProvider services={services}>
      <ToastProvider>
        <ErrorBoundary>
          <RouterProvider router={router} />
        </ErrorBoundary>
      </ToastProvider>
    </ServicesProvider>
  );
}
